import actionCreatorFactory from 'typescript-fsa';
import { NAMESPACE } from './constants';

const actionCreator = actionCreatorFactory(NAMESPACE);

export const setUserToken = actionCreator<string>('SET_USER_TOKEN');
